import Button from '@rio-cloud/rio-uikit/Button';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { AssetOverviewGotoContractsDialog } from '../../assetOverview/AssetOverviewGotoContractsDialog';
import { getServiceOverviewAutoTrackingKey } from '../serviceOverviewTracking';

interface Props {
    serviceName: string;
}

export function ManageContractsButton({ serviceName }: Props) {
    const [showDialog, setShowDialog] = useState(false);

    return (
        <>
            {showDialog && <AssetOverviewGotoContractsDialog closeDialog={() => setShowDialog(false)} />}
            <Button
                className='btn btn-primary'
                onClick={() => setShowDialog(true)}
                autoTrackingKey={getServiceOverviewAutoTrackingKey(
                    'marketplace.myServices.manageContracts',
                    serviceName
                )}
            >
                <FormattedMessage id={'intl-msg:marketplace.myServices.manageContracts'} />
            </Button>
        </>
    );
}
